import {NgModule} from '@angular/core';

import {TableOfContentsComponent} from '../components/widgets/table-of-contents/table-of-contents.component';
import {CommonModule} from '@angular/common';
import {DynamicModule} from 'ng-dynamic-component';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTreeModule} from '@angular/material/tree';
import {MatListModule} from '@angular/material/list';
import {AGSLayerList} from '../models/AGSLayerList';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatMenuModule} from '@angular/material/menu';
import {DropdownComponent} from '../components/widgets/table-of-contents/dropdown/dropdown.component';
import {TopomapsViewerEntryComponent}  from '../components/widgets/topomaps-viewer/topomaps-viewer-entry.component';
import {MatSliderModule} from '@angular/material/slider';
import {RouterModule} from '@angular/router';
import {LoadableModule} from 'ngx-loadable';
import {AttributeTableEntryComponent} from '../components/widgets/attribute-table/attribute-table-entry.component';
import {IdentifyEntryComponent} from '../components/widgets/identify/identify-entry.component';
import {LegendEntryComponent} from '../components/widgets/legend/legend-entry.component';
import {AddDataEntryComponent} from '../components/widgets/add-data/add-data-entry.component';
import {BasemapGalleryEntryComponent} from '../components/widgets/basemap-gallery/basemap-gallery-entry.component';
import {DrawEntryComponent} from '../components/widgets/draw/draw-entry.component';
import {SelectEntryComponent} from '../components/widgets/select/select-entry.component';
import {FindLocationEntryComponent} from '../components/widgets/find-location/find-location-entry.component';
import {FeedbackEntryComponent} from '../components/widgets/feedback/feedback-entry.component';
import {MeasureEntryComponent} from '../components/widgets/measure/measure-entry.component';
import {PrintEntryComponent} from '../components/widgets/print/print-entry.component';
import {QueryEntryComponent} from '../components/widgets/query/query-entry.component';
import {ReorderEntryComponent} from '../components/widgets/reorder/reorder-entry.component';
import {DisclaimerDialogComponent} from '../components/widgets/table-of-contents/disclaimer-dialog/disclaimer-dialog.component';
import {WidgetContainerModule} from './widgetContainer.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ChangelogDialogComponent} from '../components/widgets/table-of-contents/changelog-dialog/changelog-dialog.component';
import {TagFilterPipe} from './TagFilterPipe.module';
import {CheckLocalEntryComponent} from '../components/widgets/checkLocal/checkLocal-entry.component';
import {FeaturetableEntryComponent} from '../components/widgets/featuretable/featuretable-entry.component';
import {TraxsReportEntryComponent} from '../components/widgets/traxsreport/traxsreport-entry.component';

const loadableOptions = {
  moduleConfigs: [{
    name: 'attribute',
    load: () => import('./attribute.module').then(mod => mod.AttributeModule)
  }, {
    name: 'identify',
    load: () => import('./identify.module').then(mod => mod.IdentifyModule)
  }, {
    name: 'legend',
    load: () => import('./legend.module').then(mod => mod.LegendModule)
  }, {
    name: 'add-data',
    load: () => import('./add-data.module').then(mod => mod.AddDataModule)
  }, {
    name: 'basemap-gallery',
    load: () => import('./basemap-gallery.module').then(mod => mod.BasemapGalleryModule)
  }, {
    name: 'draw',
    load: () => import('./draw.module').then(mod => mod.DrawModule)
  }, {
    name: 'select',
    load: () => import('./select.module').then(mod => mod.SelectModule)
  }, {
    name: 'find-location',
    load: () => import('./find-location.module').then(mod => mod.FindLocationModule)
  }, {
    name: 'feedback',
    load: () => import('./feedback.module').then(mod => mod.FeedbackModule)
  }, {
    name: 'measure',
    load: () => import('./measure.module').then(mod => mod.MeasureModule)
  }, {
    name: 'print',
    load: () => import('./print.module').then(mod => mod.PrintModule)
  }, {
    name: 'query',
    load: () => import('./query.module').then(mod => mod.QueryModule)
  }, {
    name: 'reorder',
    load: () => import('./reorder.module').then(mod => mod.ReorderModule)
  },
  {
  name: 'checkLocal',
  load: () => import('./checkLocal.module').then(mod => mod.CheckLocalModule)
  },
  {
    name: 'featuretable',
    load: () => import('./featuretable.module').then(mod => mod.FeaturetableModule)
  },
  {
    name: 'topomaps-viewer',
    load: () => import('./topomaps-viewer.module').then(mod => mod.TopomapsViewerModule)
  },
  {
    name: 'traxsreport',
    load: () => import('./traxsreport.module').then(mod => mod.TraxsReportModule)
  }
  ]

};

const dynamicOptions = [
  AttributeTableEntryComponent,
  IdentifyEntryComponent,
  TableOfContentsComponent,
  AddDataEntryComponent,
  BasemapGalleryEntryComponent,
  FeedbackEntryComponent,
  LegendEntryComponent,
  MeasureEntryComponent,
  ReorderEntryComponent,
  QueryEntryComponent,
  PrintEntryComponent,
  DrawEntryComponent,
  SelectEntryComponent,
  FindLocationEntryComponent,
  FeaturetableEntryComponent,
  TopomapsViewerEntryComponent,
  TraxsReportEntryComponent

];

@NgModule({
  declarations: [
    TableOfContentsComponent,
    AddDataEntryComponent,
    BasemapGalleryEntryComponent,
    FeedbackEntryComponent,
    LegendEntryComponent,
    MeasureEntryComponent,
    ReorderEntryComponent,
    QueryEntryComponent,
    PrintEntryComponent,
    DropdownComponent,
    TopomapsViewerEntryComponent,
    AttributeTableEntryComponent,
    IdentifyEntryComponent,
    DrawEntryComponent,
    SelectEntryComponent,
    FindLocationEntryComponent,
    DisclaimerDialogComponent,
    ChangelogDialogComponent,
    CheckLocalEntryComponent,
    FeaturetableEntryComponent,
    TraxsReportEntryComponent
  ],
  imports: [
    CommonModule,
    WidgetContainerModule,
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatTreeModule,
    MatListModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatSliderModule,
    RouterModule,
    MatTooltipModule,
    TagFilterPipe,
    LoadableModule.forFeature(loadableOptions),
    DynamicModule
    /* DynamicModule.withComponents(dynamicOptions) */
  ],
  providers: [
    AGSLayerList
  ]
})
export class WidgetModule { }
